<template>
  <div>
    <div v-if="isProjectOneEnabled || isLegacyProjectOneEnabled" class="cart-select-p1">
      <a
        qaid="customize-btn"
        class="button button--secondary button--block"
        :href="projectOneConfiguratorUrl"
        target="_blank"
      >
        <i class="material-icons colorWheel" />
        <span v-html="bp('customize')" />
      </a>
    </div>
    <div v-else-if="isSpectrumEnabled">
      <trek-button qaid="cart-select-spectrum" block icon="build" @click="openSpectrumCustomizer">
        <span v-html="bp('customizeAndOrder')" />
      </trek-button>
    </div>
    <spectrum-customizer-overlay
      v-if="isSpectrumEnabled"
      ref="spectrumCustomizerOverlay"
      qaid="spectrum-customizer-overlay"
      :has-spectrum-open="hasSpectrumOpen"
      :spectrum-url="spectrumUrl"
      :base-properties="baseProperties"
      :options="options"
      :custom-product-starting-point="customProductStartingPoint"
      @close-spectrum-customizer="closeSpectrumCustomizer"
    ></spectrum-customizer-overlay>
  </div>
</template>
<script>
import {Url} from '@/utils/url';
import SpectrumCustomizerOverlay from '@/components/customizer/SpectrumCustomizerOverlay';
import TrekButton from '@/components/TrekButton.vue';
import {mapMutations} from 'vuex';

export default {
  name: 'PdpCustomizeProductButton',
  components: {
    TrekButton,
    SpectrumCustomizerOverlay,
  },
  props: {
    projectOneUrl: {
      type: String,
      default: '',
    },
    spectrumUrl: {
      type: String,
      default: '',
    },
    customProductStartingPoint: {
      type: String,
      default: '',
    },
    customConfiguratorType: {
      type: String,
      default: '',
    },
    siteLocale: {
      type: String,
      default: '',
    },
    isProjectOneConfiguratorActive: {
      type: Boolean,
      default: false,
    },
    baseProperties: {
      type: Array,
      default: () => [],
      required: false,
    },
    options: {
      type: Object,
      default: () => {},
    },
    successMessage: {
      type: String,
      default: '',
    },
    isB2b: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasSpectrumOpen: false,
    };
  },
  computed: {
    isProjectOneEnabled() {
      return (
        this.isProjectOneConfiguratorActive &&
        this.customProductStartingPoint &&
        this.customConfiguratorType === 'ProjectOne'
      );
    },
    isLegacyProjectOneEnabled() {
      return (
        !!this.projectOneUrl && !this.isProjectOneConfiguratorActive && this.customConfiguratorType === 'ProjectOne'
      );
    },
    isSpectrumEnabled() {
      if (this.spectrumUrl && this.customConfiguratorType === 'SpectrumBottleConfigurator')
        this.setIsSpectrumEnabled(true);
      return !!this.spectrumUrl && this.customConfiguratorType === 'SpectrumBottleConfigurator';
    },
    projectOneConfiguratorUrl() {
      let url = '';
      if (this.isProjectOneEnabled) {
        if (this.isB2b) {
          url = `${this.siteLocale}/project-one-builder/#/${this.customProductStartingPoint}`;
        } else {
          url = `/${this.siteLocale}/project-one-builder/#/${this.customProductStartingPoint}`;
        }
      } else if (this.isLegacyProjectOneEnabled) {
        url = this.projectOneUrl;
      }
      return url;
    },
  },
  created() {
    this.checkIfSpectrumCustomizerIsPreOpened();
  },
  methods: {
    checkIfSpectrumCustomizerIsPreOpened() {
      const url = new URLSearchParams(document.location.search);
      const hasSpectrumOpen = url.get('hasSpectrumOpen');
      if (hasSpectrumOpen === 'true') {
        this.$nextTick(() => {
          this.removeRedirectParametersFromUrl();
          this.openSpectrumCustomizer();
        });
      }
    },
    removeRedirectParametersFromUrl() {
      window.history.replaceState(
        null,
        document.title,
        Url.update(window.location.href, undefined, {
          removeKeys: ['hasSpectrumOpen'],
        })
      );
    },
    removeRecipeIdFromUrl() {
      window.history.replaceState(
        null,
        document.title,
        Url.update(window.location.href, undefined, {
          removeKeys: ['recipeId'],
        })
      );
    },
    openSpectrumCustomizer() {
      this.hasSpectrumOpen = !this.hasSpectrumOpen;
    },
    closeSpectrumCustomizer(value) {
      this.removeRecipeIdFromUrl();
      this.hasSpectrumOpen = value;
    },
    ...mapMutations('backend', ['setIsSpectrumEnabled']),
  },
};
</script>
